import { useToast } from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import axios, { AxiosError } from 'axios'
import { useOAuth } from 'hooks/useOAuth'
import { IRegisterInput } from 'interfaces/register.interface'
import Router from 'next/router'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { RegisterSchema } from 'schemas/register.schema'
import { UserService } from 'services/user.service'
import { messages } from 'source-of-truth/messages'
import { registerFields } from 'source-of-truth/registerFields'
import { IMembershipInvitationProps } from 'ssr/middlewares/fetchers/membershipInvitation.fetcher'
import { removeEmptyFields } from 'utils/arrayFunctions'

export const useRegister = (props: IMembershipInvitationProps) => {
  const toast = useToast()

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(RegisterSchema),
    defaultValues: {
      acceptTerms: false,
    },
  })

  const useOauth = useOAuth()

  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const [states, setStates] = useState([])

  const onSubmit = (data: IRegisterInput) => {
    removeEmptyFields(data)
    setLoading(true)

    let httpCall: (input: IRegisterInput, token?: string) => Promise<any>

    if (!!props.membershipInvitation) {
      httpCall = UserService.registerInvitation
    } else {
      httpCall = UserService.register
    }

    httpCall(data, Router.query.invitationToken)
      .then(res => {
        useOauth.handleRedirect(() => {
          toast({
            title: 'Registro completo',
            status: 'success',
            isClosable: true,
          })
          Router.push('/')
        })
      })
      .catch((error: Error | AxiosError) => {
        setLoading(false)
        if (axios.isAxiosError(error)) {
          toast({
            title: messages[error.response?.data.code] || messages.server_error,
            status: 'error',
            isClosable: true,
          })
        } else {
          toast({
            title: messages.server_error,
            status: 'error',
            isClosable: true,
          })
        }
      })
  }

  return {
    register,
    handleSubmit,
    getValues,
    errors,
    onSubmit,
    states,
    registerFields,
    loading,
    showPassword,
    setShowPassword,
    isValid,
  }
}
